module.exports = __webpack_public_path__ + "img/slider-1.c6f5c508.jpg";